import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Money } from '@websky/graphql';

interface Props {
	price: Money;
}

const CurrencyWarning: React.FC<Props> = () => {
	const { t } = useTranslation('Checkout');

	return (
		<div>
			{t(
				'All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.'
			)}
		</div>
	);
};

export default CurrencyWarning;
